const ALL = 'all';
const BY_CATEGORY = 'by_category';
const BY_TEAM = 'by_team';
const NONE = 'none';

export default {
    ALL,
    BY_CATEGORY,
    BY_TEAM,
    NONE
};